// frontend/src/services/trailers.js

/**
 * Fetch trailers from API
 * Returns top 20 trailers from popular/ongoing anime
 */
export async function fetchTrailers() {
  try {
    // Use relative URL - works with proxy in dev and same-origin in production
    const response = await fetch('/api/trailers', {
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch trailers: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching trailers:', error);
    // Return empty array on error
    return [];
  }
}

// Export empty array for backwards compatibility
// Components should use fetchTrailers() instead
export const popularTrailers = [];

// helper
export function youtubeThumb(youtubeId) {
  return `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;
}
